import './contactform.css';
import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

export default function ContactForm() {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState("");
  const [loading, setLoading] = useState(false);
  

  const sendEmail = (e) => {
    e.preventDefault(); // Prevent page reload
    setLoading(true);
    emailjs
      .sendForm(
        "service_oaojnej", // Replace with your EmailJS Service ID
        "template_bfeixmf", // Replace with your EmailJS Template ID
        form.current,
        "FuOfIvSg76WY9-rC1" // Replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          console.log(result.text);
          setStatusMessage('<b style="color:green">Message sent successfully!</b>');
          e.target.reset(); // Clear the form after submission
        },
        (error) => {
          console.error(error.text);
          setStatusMessage('<b style="color:red">Failed to send the message. Please try again later.</b>');
        }
      )
      .finally(() =>{
        setLoading(false);
      })
      
  };

  return (
    <section className="contactform">
      <div className="container">
        <h2 className="text-center">
          <b className="d-block">Let’s connect to</b> bring your ideas to life!
        </h2>
        <div className="row">
          <div className="col-md-6">
            <h3 className="mb-5">Contact Us</h3>
            <div className="contact-info">
              <p>
                <i className="far fa-phone-alt"></i>{" "}
                <span><a href="tel:+91 73070 78055">+91 73070 78055</a></span>
              </p>
              <p>
                <i className="fal fa-envelope"></i>{" "}
                <span>
                  <a href="mailto:sameer.singh@insight2activate.com">
                    sameer.singh@insight2activate.com
                  </a>
                  <a href="mailto:ritesh.ghosal@insight2activate.com">
                    ritesh.ghosal@insight2activate.com
                  </a>
                  <a href="mailto:ck.nageswaran@insight2activate.com">
                    ck.nageswaran@insight2activate.com
                  </a>
                  <a href="mailto:ankana.bhalla@insight2activate.com">
                    ankana.bhalla@insight2activate.com
                  </a>
                </span>
              </p>
              <p>
                <i className="fal fa-map-marker-alt"></i>{" "}
                <span>
                CoWorkkeys, 4th floor, 
                  <br />
                  Magnum Tower 2, Golf Course Extension Road<br/> 
                  Sector 58, 
                  <br />
                  Gurugram 122011
                </span>
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <form ref={form} onSubmit={sendEmail}>
              <div className="row g-5">
                <div className="col-md-12">
                  <h3>Leave us your info</h3>
                  <h5>
                    Let’s connect and create something extraordinary together.
                    We're here to listen, collaborate, and bring your ideas to
                    life!
                  </h5>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="from_name"
                      className="form-control"
                      placeholder="Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="phone"
                      className="form-control"
                      placeholder="Phone"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Subject"
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      name="message"
                      placeholder="Message"
                      rows="5"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? 'Sending...': 'Send Message'}
                  </button>
                  {loading && <div className='loader'></div>}
                </div>
              </div>
              {statusMessage && (<p className="status-message" dangerouslySetInnerHTML={{__html : statusMessage}}></p>)}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
